import { CustomProps, SectionScrollItemProps } from "./types";
import { scrollTo } from "utilities/scrollTo";
import React, { MouseEvent } from "react";

const SectionScrollItem = ({
  slug,
  title,
  abstract,
  isSidebar = false,
  children,
}: SectionScrollItemProps) => {
  const clickAnchorScroll = (e: MouseEvent) => {
    scrollTo({
      value: e.currentTarget.getAttribute("data-id") || "",
      type: "id",
    });
  };

  const customProps: CustomProps = {};
  if (isSidebar) {
    customProps.id = `menu-${slug}`;
    customProps["data-id"] = slug;
    customProps.onClick = clickAnchorScroll;
    customProps.rule = "button";
  } else {
    customProps.id = `${slug}`;
  }

  return (
    <div className="SectionScrollItem" {...customProps}>
      <div className="SectionScrollItem__head">
        <div className="SectionScrollItem__title">{title}</div>
        {abstract && (
          <div className="SectionScrollItem__abstract">{abstract}</div>
        )}
      </div>
      {!isSidebar && (
        <div className="SectionScrollItem__content">{children}</div>
      )}
    </div>
  );
};

export default SectionScrollItem;
